/* eslint-disable react-hooks/exhaustive-deps */
import {
  Paper,
  createStyles,
  makeStyles,
  Theme,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Grid,
  Box,
  DialogActions,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import FormInput from "../../components/Form/FormInput";
import AppButton from "../../components/Form/AppButton";
import COLORS from "../../styles/colors";
import { useLocation, useParams } from "react-router-dom";
import UploadImage from "../../components/Form/UploadImage";
import HeaderPage from "../../components/Layout/HeaderPage";
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../redux/store';
import { useHistory } from 'react-router-dom';
import { enableUpdateParams } from '../../redux/action/config-app.action';
import { useAuth } from '../../hooks/useAuth';
import useRecipeCategory from "../../hooks/useRecipeCategory";
import { initialRecipeCategory } from "../../redux/reducer/recipe-category.reducer";
import { findOneRecipeCategory } from "../../redux/action/recipe-category.action";

export default function RecipeCategoryEdit() {
  const location = useLocation();
  const history = useHistory();
  let { id } = useParams<{ id: string }>();

  const classes = useStyles();
  const dispatch = useDispatch();
  const auth = useAuth();

  const [mode, setMode] = useState<"detail" | "edit" | "create">("detail");

  const [recipeCategoryName, setRecipeCategoryName] = useState<string>('')
  const [file, setFile] = useState<any>(null);

  const recipeCategoryState = useSelector((state: ApplicationState) => state.recipeCategory)

  const { addRecipeCategory, updateOneRecipeCategory, addImageRecipeCategory} = useRecipeCategory()

  useEffect(() => {
    if (id && location.pathname.includes("edit")) {
      // edit
      setMode("edit");
      setRecipeCategoryName(recipeCategoryState.recipeCategory.recipeCategoryName)
    } else if (id) {
      // detail
      setMode("detail");
      setRecipeCategoryName(recipeCategoryState.recipeCategory.recipeCategoryName)
    } else {
      // create
      dispatch(findOneRecipeCategory(initialRecipeCategory))
      setMode("create");
    }
  }, []);

  const cancel = () => {
    dispatch(enableUpdateParams(false))
    history.go(-1)
  };

  const submit = async () => {
    
    let data: any = {
      recipeCategoryName
    }

    if (id) {
      data = {
        ...data,
        recipeCategoryId: id
      }
    }

    let res

    if (id) {
      res = await updateOneRecipeCategory(data)
    } else {
      res = await addRecipeCategory(data)
    }

    if(file){
      let image = new FormData
      image.append('image', file)
      image.append('recipeCategoryId', res?.data.payload.recipeCategoryId)
      await addImageRecipeCategory(image)
    }

    setRecipeCategoryName('')
    setFile(null)
    history.go(-1);
  };

  let title = "";
  let subtitle = "";

  if (mode === "create") {
    title = "Create Recipe Category";
    subtitle = "Create new recipe category";
  } else if (mode === "edit") {
    title = "Edit Recipe Category";
    subtitle = "Edit recipe category";
  } else if (mode === "detail") {
    title = "Detail Recipe Category";
    subtitle = "Detail recipe category";
  }

  return (
    <Layout title={title}>
      <Grid container justify="space-between" spacing={3} alignItems="center">
        <Grid item xs={12} md={6} lg={mode === "detail" ? 10 : 8}>
          <HeaderPage title={title} subtitle={subtitle} showBackButton />
        </Grid>

        {(mode === "edit" || mode === "create") && (
          <Grid item xs={6} md={6} lg={2}>
            <AppButton fullWidth color="secondary" onClick={cancel}>
              Cancel
              </AppButton>
          </Grid>
        )}
        {(mode === "edit" || mode === "create") && (
          <Grid item xs={6} md={6} lg={2}>
            <AppButton loading={recipeCategoryState.isLoadingRecipeCategory} fullWidth color="primary" onClick={submit}>
              Save
              </AppButton>
          </Grid>
        )}
        {mode === "detail" && (
          <Grid item xs={12} md={6} lg={2} alignItems="flex-end" justify="flex-end">
            <AppButton onClick={() => setMode("edit")} color="primary" style={{ width: '100%' }}>
              Edit
              </AppButton>
          </Grid>
        )}
      </Grid>

      <Paper elevation={3} className={classes.paper}>
        <Grid container spacing={3} className={classes.containerForm}>
          {/* <Box width="100%" className={classes.input}>
            <Typography>Category Image</Typography>

            <Card className={classes.cardRoot}>
              <CardActionArea className={classes.cardActionArea}>
                <CardMedia
                  className={classes.cardMedia}
                  image="assets/default_500x500.png"
                  title="Contemplative Reptile"
                  component="img"
                />
              </CardActionArea>
            </Card>

            <Box
              display="flex"
              alignItems="center"
              style={{
                marginTop: 10,
                marginBottom: 10,
                backgroundColor: COLORS.greyLighten,
                borderRadius: 10,
              }}
            >
              <AppButton color="secondary">
                <CloudUploadOutlined />
                &nbsp;&nbsp;&nbsp;Browse Image
              </AppButton>
              <Box flexGrow={1}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  style={{ fontStyle: "italic" }}
                >
                  No file selected.
                </Typography>
              </Box>
            </Box>
            <Box>
              <Typography variant="subtitle1">
                Recommended image dimension: <b>500x500 px</b>, Max image size:
                <b>1MB</b>, Supported file type are <b>jpg, jpeg and png</b>.
              </Typography>
            </Box>
          </Box> */}
          <UploadImage
            image={recipeCategoryState.recipeCategory.imageUrl || ''}
            title="Recipe Category Image"
            onFileSelected={(e: any) => setFile(e)}
            editable={mode === "edit" || mode === "create"}
          />
          <Grid container spacing={3} justify="space-between" style={{ marginTop: 16 }}>
            <Grid item xs={12} className={classes.input}>
              <FormInput
                readOnly={mode === 'detail'}
                onChange={(value: any) => setRecipeCategoryName(value)}
                fullWidth
                required
                placeholder="Recipe Category name"
                value={recipeCategoryName}
                label="Recipe Category Name"
              />
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Layout>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      margin: theme.spacing(2, 0, 0, 0),
      padding: theme.spacing(2),
    },
    containerForm: {
      padding: 20,
    },
    input: {
      padding: theme.spacing(0, 0, 1, 0),
    },
    paperTitle: {
      padding: theme.spacing(2),
    },
    containerButton: {
      flexDirection: "row",
      padding: theme.spacing(2),
    },
    formStatus: {
      width: "100%",
      margin: theme.spacing(0, 0, 2, 0),
    },
    cardRoot: {
      width: "100%",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      backgroundColor: COLORS.greyLighten,
      marginTop: 10,
    },
    cardMedia: {
      height: 200,
      width: 200,
      alignSelf: "center",
      backgroundColor: COLORS.accent,
      borderColor: COLORS.accent,
      borderWidth: 1,
      borderStyle: "solid",
      borderRadius: 10,
    },
    cardActionArea: {
      display: "flex",
      padding: 10,
    },
  })
);
